import React, {useState, useEffect, Fragment} from "react";
import {connect} from "react-redux";

import Typography from "@material-ui/core/Typography";

import {firestore} from "../../../../../firebase";
import * as actions from "../../../../../store/actions";
import EnhancedTable from "../../../../../components/UI/Table/Table";
import TransitionModal from "../../../../../components/UI/Modal/Modal";
import Delete from "./Delete/Delete";
import Add from "./Add/Add";
import Edit from "./Edit/Edit";

const headCells = [
    {label: 'Name'}
];

const EditPositions = ({positionList, fetchPositionList}) => {
    const [positions, setPositions] = useState([...positionList]);
    const [editOpen, setEditOpen] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [formData, setFormData] = useState({});
    const [rankEditMode, setRankEditMode] = useState(false);

    useEffect(() => {
        setPositions(positionList);
    }, [positionList]);

    //add modal functions
    const handleAddOpen = () => {
        setAddOpen(true);
    };

    const handleAddClose = () => {
        setAddOpen(false);
    };

    function addPosition() {
        fetchPositionList();
        handleAddClose();
    }

    //edit modal functions
    const handleEditOpen = (position, index) => {
        setFormData({position, index});
        setEditOpen(true);
    };

    const handleEditClose = () => {
        setEditOpen(false);
    };

    function editPosition() {
        fetchPositionList();
        handleEditClose();
    }

    //delete modal functions
    const handleDeleteOpen = (row) => {
        setFormData(row);
        setDeleteOpen(true);
    };

    const handleDeleteClose = () => {
        setDeleteOpen(false);
    };

    const deletePosition = (formData) => {
        let tempList = positions.filter(position => position !== formData);
        firestore.collection('positions')
            .doc('positions')
            .update({
                positions: tempList
            })
            .then(() => fetchPositionList())
            .catch(error => console.log(error));
        handleDeleteClose();
    };

    const moveUp = (index) => {
        if (index === 0) return;
        const newData = [...positions];
        const temp = newData[index];
        newData[index] = newData[index - 1];
        newData[index - 1] = temp;
        setPositions(newData);
    };

    const moveDown = (index) => {
        if (index === positions.length - 1) return;
        const newData = [...positions];
        const temp = newData[index];
        newData[index] = newData[index + 1];
        newData[index + 1] = temp;
        setPositions(newData);
    };

    const handleSwitch = () => {
        setRankEditMode(prevState => {
            const newEditMode = !prevState;
            if (!newEditMode) {
                firestore.collection('positions')
                    .doc('positions')
                    .update({
                        positions: positions
                    })
                    .then(() => {
                        fetchPositionList();
                    })
                    .catch(error => console.log(error));
            }
            return newEditMode;
        })
    };

    const switchLabel = rankEditMode ? "Save Position Order" : "Enable Position Order Edit Mode";

    return (
        <Fragment>
            <Typography variant="h4">Edit Positions</Typography>
            <EnhancedTable
                data={positions}
                headCells={headCells}
                delete={handleDeleteOpen}
                add={handleAddOpen}
                handleSwitch={handleSwitch}
                switchLabel={switchLabel}
                switchValue={rankEditMode}
                moveUp={rankEditMode && moveUp}
                moveDown={rankEditMode && moveDown}
                // edit={handleEditOpen}
            />
            <TransitionModal
                open={editOpen}
                handleOpen={handleEditOpen}
                handleClose={handleEditClose}
                form={<Edit formData={formData} onEdit={editPosition} handleClose={handleEditClose}
                            positionList={positions}/>}
                title={"Edit Position"}
            />
            <TransitionModal
                open={addOpen}
                handleOpen={handleAddOpen}
                handleClose={handleAddClose}
                form={<Add onAdd={addPosition} handleClose={handleAddClose} positionList={positions}/>}
                title={"Add Position"}
            />
            <TransitionModal
                open={deleteOpen}
                handleOpen={handleDeleteOpen}
                handleClose={handleDeleteClose}
                form={<Delete formData={formData} submit={deletePosition} cancel={handleDeleteClose}/>}
                title={"Are You Sure?"}
            />
        </Fragment>
    )
};

const mapStateToProps = state => {
    return {
        positionList: state.lists.positionList,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchPositionList: () => dispatch(actions.fetchPositionList())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPositions);
